<div class="row w-100 m-0 p-0 justify-content-center" style="width: 100vw; position: fixed; height: 100vh">
  <div class="col-3 m-0 p-0 d-flex justify-content-start" style="height: 85%; overflow-y: scroll"></div>
  <div class="col-6 m-0 p-0 d-flex justify-content-center" style="height: 85%; overflow-y: scroll">
    <app-my-calendar style="width: 100%"></app-my-calendar>
  </div>
  <div class="col-3 m-0 p-0 d-flex justify-content-end" style="height: 85%; overflow-y: scroll"></div>
</div>
